module.exports = {
    // Variant of the forms. This values affect both behavior (rendering logic) and ui (css styles).
    // Please look for both of the usages if modifying the key or the string value.
    minimal: 'minimal-form',
    inverted: 'inverted-form',
    promo: 'promo-form'
};


/** WEBPACK FOOTER **
 ** ./src/constants/form-variant.js
 **/